import React, { Suspense } from 'react';
import { ProductSkeletonGrid } from './ProductSkeleton';

// Generic lazy wrapper component
const LazyWrapper = ({ 
  children, 
  fallback = <ProductSkeletonGrid count={4} />,
  errorFallback = <div className="text-center py-8 text-red-500">שגיאה בטעינת הקומפוננט</div>
}) => {
  return (
    <Suspense fallback={fallback}>
      <ErrorBoundary fallback={errorFallback}>
        {children}
      </ErrorBoundary>
    </Suspense>
  );
};

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Component error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default LazyWrapper;

